import React, { useState } from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  Button,
  Paper,
  InputLabel,
  FormHelperText,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts

// Components

const useStyles = makeStyles((theme) => ({
  paper: {
    width: 248,
    height: 211,
    overflow: "auto",
    border: "0.2px solid lightgrey",
  },
  paperError: {
    width: 248,
    height: 211,
    overflow: "auto",
    border: "0.2px solid",
    borderColor: theme.palette.error.main,
  },
  root: {
    marginTop: "0.5rem",
  },
  buttonBox: {
    padding: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
}));

const TransferList = ({
  title,
  data_list,
  handleTransferList,
  errorMessage,
}) => {
  const classes = useStyles();

  // TRANSFER LIST
  const not = (a, b) => {
    return a.filter((value) => b.indexOf(value) === -1);
  };
  const intersection = (a, b) => {
    return a.filter((value) => b.indexOf(value) !== -1);
  };

  const sorting = (a, b) => {
    if (data_list.indexOf(a) > data_list.indexOf(b)) return 1;
    else return -1;
  };

  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState(data_list);
  const [right, setRight] = useState([]);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleCheckedRight = () => {
    const newArr = right.concat(leftChecked);
    newArr.sort(sorting);

    setRight(newArr);
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));

    handleTransferList(newArr);
  };

  const handleCheckedLeft = () => {
    const newArr = left.concat(rightChecked);
    newArr.sort(sorting);

    setLeft(newArr);
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));

    handleTransferList(not(right, rightChecked));
  };

  const customList = (items) => (
    <Paper className={errorMessage ? classes.paperError : classes.paper}>
      <List dense component="div" role="list">
        {" "}
        {items.map((each) => {
          const labelId = `transfer-list-item-${each}-label`;

          return (
            <ListItem
              key={each}
              role="listitem"
              button
              onClick={handleToggle(each)}
              style={{
                padding: 0,
              }}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(each) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    "aria-labelledby": labelId,
                  }}
                />{" "}
              </ListItemIcon>{" "}
              <ListItemText id={labelId} primary={each} />{" "}
            </ListItem>
          );
        })}{" "}
      </List>{" "}
    </Paper>
  );

  return (
    <Grid
      item
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      className={classes.root}
    >
      <Grid item xs={12}>
        <InputLabel shrink> {title} </InputLabel>{" "}
      </Grid>
      <Grid item>
        <FormHelperText error> {errorMessage && <br />} </FormHelperText>{" "}
        {customList(left)}{" "}
      </Grid>
      <Grid item className={classes.buttonBox}>
        <Grid container direction="column" alignItems="center">
          <Button
            variant="outlined"
            size="small"
            className={classes.button}
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label="move selected right"
          >
            & gt;{" "}
          </Button>{" "}
          <Button
            variant="outlined"
            size="small"
            className={classes.button}
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label="move selected left"
          >
            & lt;{" "}
          </Button>{" "}
        </Grid>{" "}
      </Grid>
      <Grid item>
        <FormHelperText error> {errorMessage} </FormHelperText>{" "}
        {customList(right)}{" "}
      </Grid>{" "}
    </Grid>
  );
};

export default TransferList;
